<div class="row justify-content-center">
    
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Tipos IPV</h4>
            </div>
            <div class="card-body">
                
                <h3 class="card-title">Listado de valores</h3>
                <hr>
                    <div *ngFor="let factor of factors" class="form-body">
                            
                        <div class="col-md-12 text-center">
                            <h2 *ngIf="factor.name == 'DGV'">Valor: {{factor.name}}</h2>
                            <h2 *ngIf="factor.name == 'I'">Valor: {{factor.name}} - Comprensión</h2>
                            <h2 *ngIf="factor.name == 'II'">Valor: {{factor.name}} - Adaptabilidad</h2>
                            <h2 *ngIf="factor.name == 'III'">Valor: {{factor.name}} - Control de si mismo</h2>
                            <h2 *ngIf="factor.name == 'IV'">Valor: {{factor.name}} - Tolerancia a la frustración</h2>
                            <h2 *ngIf="factor.name == 'V'">Valor: {{factor.name}} - Combatividad</h2>
                            <h2 *ngIf="factor.name == 'VI'">Valor: {{factor.name}} - Dominio</h2>
                            <h2 *ngIf="factor.name == 'VII'">Valor: {{factor.name}} - Seguridad</h2>
                            <h2 *ngIf="factor.name == 'VIII'">Valor: {{factor.name}} - Actividad</h2>
                            <h2 *ngIf="factor.name == 'IX'">Valor: {{factor.name}} - Sociabilidad</h2>
                            
                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Muy bajo (Menor a 2)</h3>
                                    <p>{{factor.veryLowDesc}}</p>
                                </div>
                            </div>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Bajo (Entre 2.1 - 4)</h3>
                                    <p>{{factor.lowDesc}}</p>
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Promedio (Entre 4.1 - 6)</h3>
                                    <p>{{factor.midDesc}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Mayor que promedio (Entre 6.1 - 8)</h3>
                                    <p>{{factor.highDesc}}</p>
                                </div>
                            </div>

                        </div>

                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>Alto (Mayor a 8)</h3>
                                    <p>{{factor.veryHighDesc}}</p>
                                </div>
                            </div>

                        </div>
                        <button type="button" class="btn waves-effect waves-light btn-danger"(click)="handleDelete(factor)">Borrar</button>

                        <hr>
                    </div>
                    
                
            </div>
        </div>
    </div>
</div>